

















































































































































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      items: {
        materials: [
          {
            name: 'Questões',
            routeName: 'question_index',
            url: '/questoes/',
          },
          {
            name: 'Explicações',
            routeName: 'article_index',
            url: '/explicacoes/',
          },
          {
            name: 'Provas',
            routeName: 'exam_index',
            url: '/provas/',
          },
          {
            name: 'Simulados',
            routeName: 'exam_group_index',
            url: '/simulados/',
          },
          {
            name: 'Listas',
            routeName: 'list_index',
            url: '/listas/',
          },
        ],
        question_sources: [
          {
            name: 'Bancas',
            routeName: 'examination_board_index',
            url: '/bancas/',
          },
          {
            name: 'Instituições',
            routeName: 'institution_index',
            url: '/instituicoes/',
          },
          {
            name: 'Fonte das questões',
            routeName: 'exam_application_index',
            url: '/fontes/',
          },
          {
            name: 'Formatos',
            routeName: 'exam_mode_index',
            url: '/formatos/',
          },
        ],
        aggregators: [
          {
            name: 'Cursos',
            routeName: 'course_index',
            url: '/cursos/',
          },
          {
            name: 'Turmas',
            routeName: 'classroom_index',
            url: '/turmas/',
          },
          {
            name: 'Murais/Disciplinas',
            routeName: 'board_index',
            url: '/murais/',
          },
          {
            name: 'Seções',
            routeName: 'board_section_index',
            url: '/secoes/',
          },
        ],
        users: [
          {
            name: 'Reports',
            routeName: 'report_index',
            url: '/reports/',
          },
          {
            name: 'Perguntas',
            routeName: 'feedback_question_index',
            url: '/perguntas/',
          },
        ],
        knowledges: [
          {
            name: 'Criação e visualização',
            routeName: 'knowledge_create',
            url: '/criar_conhecimento/',
          },
          {
            name: 'Redefinir associações',
            routeName: 'redefine_knowledges',
            url: '/refinir_associacoes/',
          },
        ],
        admins: [
          {
            name: 'Admins',
            routeName: 'user_index',
            url: '/admins/',
          },
        ],
        schools: [
          {
            name: 'Relatórios',
            routeName: 'exam_reports',
            url: '/escolas/relatorios',
          },
          {
            name: 'Gestores',
            routeName: 'school_managers',
            url: '/escolas/gestores',
          },
          {
            name: 'Planejamento Semanal',
            routeName: 'school_weekplanning',
            url: '/escolas/planejamento',
          },
        ],
      },
    };
  },
  computed: {
    currentPage(): any {
      return this.$route.name;
    },
  },

  methods: {
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
});
